<template>
  <div id="LoadingView">
    <v-card class="border">
      <v-row>
        <v-col align="center">
          <v-img
            mx-auto
            src="@/assets/images/icons/Spinner-5.gif"
            v-show="isLoading"
            max-width="75px"
          />
          <router-view v-show="!isLoading" />
        </v-col>
      </v-row>
      <v-row>
        <v-col align="right">
          <ValenzFooterView />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ValenzFooterView from "@/components/general/ValenzFooterView.vue";

export default {
  name: "MainView",
  components: { ValenzFooterView },
  computed: {
    isLoading() {
      return this.$store.getters.getIsLoading;
    },
  },
};
</script>

<style lang="scss" scoped>
#LoadingView {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.border {
  border: 3px solid black;
  padding: 1vh;
  min-width: 400px;
  width: 50%;
  margin: auto;
  margin-top: 5%;
}
</style>
